let header = "#headerWrap"


$('#menu-button').on('click', () => {
    $('#menu-button').toggleClass('active')
    $('#mobile_controller').toggleClass('show')
    console.log('click!')
})

$(document).ready(function() {
    headerChange();
    $(window).scroll(function () {
        headerChange();
    });
});

function headerChange() {
    if ($(window).scrollTop() != 0 && $(window).width() > 991) {
        $(header).addClass('is-small')
        $(header).addClass('is-fixed')
    } else if ($(window).scrollTop != 0 && $(window).width() <= 991) {
        $(header).addClass('scroll')
        $(header).removeClass('is-small')
        $(header).removeClass('is-fixed')
    } else {
        $(header).removeClass('is-small')
        $(header).removeClass('is-fixed')
        $(header).removeClass('scroll')
    }
}